import { Typography } from "@suraasa/placebo-ui"
import { type MouseEvent, useEffect, useState } from "react"

interface NavItem {
  id: string
  label: string
  isActive?: boolean
}
interface OnThisPageProps {
  items: NavItem[]
}
const OnThisPage = ({ items }: OnThisPageProps) => {
  const [activeId, setActiveId] = useState<string | undefined>(items[0]?.id)

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setActiveId(entry.target.id)
          }
        })
      },
      {
        rootMargin: "-10% 0px -80% 0px",
        threshold: 0,
      }
    )

    items.forEach(item => {
      const element = document.getElementById(item.id)
      if (element) observer.observe(element)
    })

    return () => observer.disconnect()
  }, [items])

  const handleScrollTo = (e: MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault()
    const element = document.getElementById(id)
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" })
      setActiveId(id)
    }
  }

  return (
    <nav className="hidden space-y-1 md:block">
      <Typography variant={"smallBody"} className="mb-1 text-onSurface-500">
        On this page
      </Typography>

      <div className="space-y-0">
        {items.map((item, index) => {
          const isActive = activeId === item.id
          return (
            <div key={item.id} className="flex items-stretch">
              <div
                className={`mr-3 w-0.5 shrink-0 transition-colors ${
                  isActive ? "rounded-full bg-onSurface-500" : "bg-surface-200"
                } ${index === 0 ? "rounded-t-full" : ""} ${
                  index === items.length - 1 ? "rounded-b-full" : ""
                }`}
              />
              <a href={`#${item.id}`} onClick={e => handleScrollTo(e, item.id)}>
                <Typography
                  variant={"smallBody"}
                  className={`my-1 transition-colors ${
                    isActive
                      ? "!font-semibold"
                      : "text-onSurface-500 hover:text-black-200"
                  }`}
                >
                  {item.label}
                </Typography>
              </a>
            </div>
          )
        })}
      </div>
    </nav>
  )
}
export default OnThisPage
